import React, { useContext, useReducer, useEffect } from "react";
import clsx from "clsx";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import { useLazyQuery } from "@apollo/client";
// import { toast } from "react-toastify";
// import DialogTitle from "@mui/material/DialogTitle";
// import Dialog from "@mui/material/Dialog";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
// import FindInPageIcon from "@mui/icons-material/FindInPage";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { VoAppContext } from "services/GlobalState";
import { reducer } from "@vocollege/app/dist/modules/VoHelpers";
import { useStyles } from "./styles";
// import EntityField from "@vocollege/components/dist/Form/fields/EntityField";
import { EntityPickerItem } from "@vocollege/components/dist/Form";
import EntityPicker from "@vocollege/components/dist/Form/fields/EntityPicker";
import VoLoader from "@vocollege/components/dist/VoLoader";
import { GroupSelectProps } from "./global";
import { SEARCH_GROUP } from "@vocollege/app/dist/modules/VoApi";
import { localStorage } from "@vocollege/app/dist/modules/VoHelpers";
import VoConfig from "@vocollege/app/dist/modules/VoConfig";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import VoGroups from "@vocollege/app/dist/modules/VoGroups";

const initialState = {
  changing: false,
};

const GroupSelect: React.FC<GroupSelectProps> = (props) => {
  const { className } = props;
  const { state: globalState } = useContext(VoAppContext);
  const [state, dispatch] = useReducer(reducer, initialState);
  const classes = useStyles();

  // Methods.

  // const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { value } = e.target;
  //   dispatch({ key: "searchResults", values: null });
  //   dispatch({ key: "searchTerm", values: value });
  //   if (value && value !== "" && value.length > 2) {
  //     clearTimeout(typingTimer);
  //     typingTimer = window.setTimeout(async () => {
  //       searchItems({
  //         variables: {
  //           search: value,
  //         },
  //       });
  //     }, 300);
  //   }
  // };

  const canReset = () => {
    return (
      (VoAuth.currentUser && VoAuth.currentUser.groups.length !== 1) ||
      VoAuth.globalAbility.can("bypass_group_check", "Global")
    );
  };

  const canChangeGroup = () => {
    return (
      (VoAuth.currentUser && VoAuth.currentUser.groups.length > 1) ||
      VoAuth.ability.can("bypass_group_check", "Global") ||
      VoAuth.globalAbility.can("bypass_group_check", "Global")
    );
  };

  const handleSelect = (item: EntityPickerItem | null) => {
    dispatch({ key: "changing", values: true });
    if (!item) {
      localStorage.remove(VoConfig.get.CURRENT_GROUP);
    } else {
      localStorage.set(VoConfig.get.CURRENT_GROUP, JSON.stringify(item));
    }
    window.location.href = "/";
  };

  // Effects.

  useEffect(() => {
    let currentGroup = VoGroups.getCurrent();
    if (
      VoAuth.currentUser &&
      VoAuth.currentUser.groups.length === 1 &&
      !currentGroup &&
      VoAuth.ability.cannot("bypass_group_check", "Global")
    ) {
      handleSelect(VoAuth.currentUser.groups[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [VoAuth.currentUser]);

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.labelWrapper}>
        <Typography className={classes.label} variant="body2" color="inherit">
          {globalState.group
            ? globalState.group.title
            : I18n.get.group.labels.noGroup}
        </Typography>
      </div>
      {globalState.group && canReset() && (
        <IconButton
          color="inherit"
          onClick={() => handleSelect(null)}
          className={classes.resetButton}
        >
          <CloseIcon />
        </IconButton>
        // <Button
        //   size="small"
        //   color="success"
        //   onClick={() => handleSelect(null)}
        //   // className={classes.resetButton}
        // >
        //   <CloseIcon />
        // </Button>
      )}
      {canChangeGroup() && (
        <EntityPicker
          // className={classes.button}
          dialog={{
            onSelect: handleSelect,
            open: false,
            types: ["group"],
            // renderTitleField: (item: any) => getUserString(item),
            query: SEARCH_GROUP,
            category: "searchGroup",
          }}
          disableButtonLabel
          // buttonLabel={<FindInPageIcon />}
          buttonColor="inherit"
        />
      )}
      {/* <EntityField
        name="group"
        label={I18n.get.group.labels.currentGroup}
        value={globalState.group}
        // onChange={(item) =>
        //   handleEntityFieldChange(
        //     "licenseAdmin",
        //     "general",
        //     item.id
        //   )
        // }
        // onReset={() =>
        //   handleEntityFieldChange("licenseAdmin", "general", "")
        // }
        required={true}
        dialog={{
          types: ["group"],
          // renderTitleField: (item: any) => getUserString(item),
          query: SEARCH_GROUP,
          category: "searchGroup",
        }}
      /> */}

      {state.changing && <VoLoader />}
    </div>
  );
};

export default GroupSelect;
